import React, { useState, useEffect, lazy, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SectionModal.css";
import Ingredients from "./ModalComponents/Ingredients";
import ProductBenefit01 from "./ModalComponents/ProductBenefit01";
import ProductBenefit03 from "./ModalComponents/ProductBenifit03";
import ProductBenefit02 from "./ModalComponents/ProductBenefit02";
const FAQAsync = lazy(() => import("./ModalComponents/Faq.jsx"));
const ProductBenefit01Async = lazy(() =>
  import("./ModalComponents/ProductBenefit01.jsx")
);
const IngredientsAsync = lazy(() => import("./ModalComponents/Ingredients"));

const SectionModal = ({
  isOpen,
  onClose,
  onAddSection,
  previewMode,
  openCustomModal,
  initialSku,
  keywords,
  agentId,
  sessionId,
  language,
  locationFocus,
  furtherDetails,
}) => {
  const [sectionData, setSectionData] = useState({});
  const [showCustomModal, setShowCustomModal] = useState(false);

  const SECTION_TEMPLATES = [
    {
      id: 1,
      type: "benefit",
      title: "Product Benefits",
      image: "/product-benifit.svg",
      component: () => (
        <Suspense fallback={<div>Loading Benefits...</div>}>
          <ProductBenefit01Async
            previewMode={previewMode}
            initialSku={initialSku}
            keywords={keywords}
            agentId={agentId}
            sessionId={sessionId}
            language={language}
            locationFocus={locationFocus}
            furtherDetails={furtherDetails}
          />
        </Suspense>
      ),
    },
    {
      id: 2,
      type: "benefits03",
      title: "Product Benefits 1",
      image: "/product-benifit-2.svg",
      component: () => (
        <ProductBenefit02
          previewMode={previewMode}
          initialSku={initialSku}
          keywords={keywords}
          agentId={agentId}
          sessionId={sessionId}
          language={language}
          locationFocus={locationFocus}
          furtherDetails={furtherDetails}
        />
      ),
    },
    {
      id: 3,
      type: "benefits04",
      title: "Product Benefits 2",
      image: "/product-benifit-3.svg",
      component: () => (
        <ProductBenefit03
          previewMode={previewMode}
          initialSku={initialSku}
          keywords={keywords}
          agentId={agentId}
          sessionId={sessionId}
          language={language}
          locationFocus={locationFocus}
          furtherDetails={furtherDetails}
        />
      ),
    },
    {
      id: 4,
      type: "detailed_ingredients",
      title: "Detailed Ingredients",
      image: "/ingredients.svg",
      component: () => (
        <Suspense fallback={<div>Loading Ingredients...</div>}>
          <IngredientsAsync
            previewMode={previewMode}
            initialSku={initialSku}
            keywords={keywords}
            agentId={agentId}
            sessionId={sessionId}
            language={language}
            locationFocus={locationFocus}
            furtherDetails={furtherDetails}
          />
        </Suspense>
      ),
    },
    {
      id: 5,
      type: "faq",
      title: "Frequently asked questions",
      image: "/faq.svg",
      component: () => (
        <Suspense fallback={<div>Loading FAQ...</div>}>
          <FAQAsync
            previewMode={previewMode}
            initialSku={initialSku}
            keywords={keywords}
            agentId={agentId}
            sessionId={sessionId}
            language={language}
            locationFocus={locationFocus}
            furtherDetails={furtherDetails}
          />
        </Suspense>
      ),
    },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSection, setSelectedSection] = useState(null);

  if (!isOpen) return null;

  const handleAdd = () => {
    if (selectedSection) {
      onAddSection(selectedSection);
      handleOnClose();
    }
  };
  const handleOnClose = () => {
    setSelectedSection(null);
    onClose();
  };

  const filteredSections = SECTION_TEMPLATES.filter((section) =>
    section.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && handleOnClose()}
    >
      <div className="section-modal">
        <div className="modal-header">
          <h3 className="modal-title">Add new section</h3>
          <button className="close-button" onClick={handleOnClose}>
            &times;
          </button>
        </div>

        <div className="search-filter-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="filter-button">
            <span>Filter</span>
            <i className="bi bi-funnel"></i>
          </button>
        </div>

        <p className="mb-3">Choose from</p>

        <div className="sections-grid">
          {filteredSections.map((section) => (
            <div
              key={section.id}
              className={`section-preview ${
                selectedSection?.id === section.id
                  ? "selected border border-danger"
                  : ""
              }`}
              onClick={() => setSelectedSection(section)}
            >
              <img src={section.image} alt={section.title} />
              <h4>{section.title}</h4>
            </div>
          ))}
        </div>
        <div className="d-flex gap-4">
          <button
            className="add-button"
            disabled={!selectedSection}
            onClick={handleAdd}
          >
            Add
          </button>
          <button className="add-button" onClick={openCustomModal}>
            Add Custom Section
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionModal;
